<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título -->
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">Deudores</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes visualizar la situación consolidada por cada deudor al que se le deben cobrar facturas.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador + botón -->
      <v-row class="d-flex ma-0 mb-4" justify="space-between" align="center">
        <v-col cols="12" sm="6" md="4" class="pl-0 py-0">
          <v-text-field
            v-model="textoBusqueda"
            label="Buscar deudor"
            clearable
            outlined
            hide-details
            class="mr-2"
            style="font-family: 'montserrat-medium'; border-radius: 20px;"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="d-flex justify-end">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="crearDeudor()">
            Crear Deudor
          </v-btn>
        </v-col>
      </v-row>

      <!-- Tabla Desktop -->
      <v-data-table class="d-none d-sm-block" hide-default-header :items="deudoresFiltrados">
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Deudor</th>
              <th class="header__title center">Clientes asociados</th>
              <th class="header__title center">Pendientes por aprobar</th>
              <th class="header__title center">Fact. vencidas</th>
              <th class="header__title center">Monto vencido</th>
              <th class="header__title center">Total por cobrar</th>
              <th class="header__title center">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="deudor in items" :key="deudor.id">
              <td class="table__item">{{ deudor.deudor }}</td>
              <td class="table__item center">{{ deudor.clientes_asociados }}</td>
              <td class="table__item center">{{ deudor.pendientes_aprobar }}</td>
              <td class="table__item center" :class="deudor.facturas_vencidas > 0 ? 'red--text' : ''">{{ deudor.facturas_vencidas }}</td>
              <td class="table__item center" :class="deudor.monto_vencido > 0 ? 'red--text' : ''">{{ "$ " + formatMoney(deudor.monto_vencido) + " USD" }}</td>
              <td class="table__item center">{{ "$ " + formatMoney(deudor.total_por_cobrar) + " USD" }}</td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="verDetalle(deudor)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalle</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla Mobile -->
      <v-data-table class="d-sm-none d-block" hide-default-header :items="deudoresFiltrados">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="deudor in items" :key="deudor.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>Deudor</strong><div>{{ deudor.nombre }}</div></td>
              <td class="table__item__mobile"><strong>Clientes asociados</strong><div>{{ deudor.clientes_asociados }}</div></td>
              <td class="table__item__mobile"><strong>Pendientes por aprobar</strong><div>{{ deudor.pendientes_aprobar }}</div></td>
              <td class="table__item__mobile"><strong>Fact. vencidas</strong><div>{{ deudor.facturas_vencidas }}</div></td>
              <td class="table__item__mobile"><strong>Monto vencido</strong><div>{{ "$ " + formatMoney(deudor.monto_vencido) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Total por cobrar</strong><div>{{ "$ " + formatMoney(deudor.total_por_cobrar) + " USD" }}</div></td>
              <td class="table__item__mobile d-flex justify-end">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="verDetalle(deudor)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalle</span>
                </v-tooltip>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      textoBusqueda: '',
      debtors: [],
    }
  },
  computed: {
    deudoresFiltrados() {
      if (!this.textoBusqueda) return this.debtors
      const busqueda = this.textoBusqueda.toLowerCase()
      return this.debtors.filter(e => e.nombre.toLowerCase().includes(busqueda))
    }
  },
  methods: {
    async getEnterprises() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/admin/debtors`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.debtors = response.data.debtors;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney (value) {
      let multiplied = value * 100
      let rounded = Math.round(multiplied)
      let formattedNumber = rounded / 100
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber)
    },
    verDetalle (deudor) {
      this.$router.push({ name: 'detalleDeudor', params: { deudorId: deudor.enterpriseId } })
    },
    crearDeudor () {
      this.$router.push({ name: 'crearDeudor' })
    }
  },
  beforeMount() {
    this.getEnterprises();
  }
}
</script>
